import React from 'react'
import { PreviewBody, PreviewLayout } from '../sub-components/PreviewLayout'
import { PaymentOffersPageType } from 'src/lib/types/uiPreview'
import PreviewPaymentMethodsOffers from '../sub-components/PreviewPaymentMethodsOffers'
import { Lock } from 'mdi-material-ui'

const PaymentOffersPage: React.FC<PaymentOffersPageType> = ({ paymentMethods }) => {
  return (
    <PreviewLayout>
      <>
        <PreviewBody>
          <PreviewPaymentMethodsOffers paymentMethods={paymentMethods} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }}
          >
            <Lock sx={{ height: 12, width: 12, marginBottom: 0.5 }} />
            <span className='text-xs font-normal'>Secured by </span>
            <img src={'/images/flo-full-logo-mono.svg'} style={{ height: '11px' }} alt={'shopflo-logo'} />
          </div>
          <div className='w-full h-16' />
        </PreviewBody>
      </>
    </PreviewLayout>
  )
}

export default PaymentOffersPage
